import gql from "graphql-tag";

import {useQuery} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    coachDetails_user_parents as Parents,
    coachDetails_user_teachers as Teachers,
} from "./__graphql-types__/coachDetails.ts";
import type {coachDetailsType} from "./__graphql-types__/index.ts";

export const USE_COACH_DETAILS_QUERY: GqlOperation<
    coachDetailsType["response"],
    coachDetailsType["variables"]
> = gqlOp(gql`
    query coachDetails {
        user {
            id
            parents {
                id
            }
            teachers: coaches(coachType: TEACHER) {
                id
            }
        }
    }
`);

export interface CoachedDetails {
    parents: Array<Parents> | null | undefined;
    teachers: Array<Teachers> | null | undefined;
}

export const useCoachDetails = (): CoachedDetails => {
    const [queryResult] = useQuery(USE_COACH_DETAILS_QUERY);

    if (queryResult.status !== "success") {
        return {
            parents: null,
            teachers: null,
        };
    }

    const parentsDetails: Array<Parents> = queryResult.data.user?.parents ?? [];
    const teacherDetails: Array<Teachers> =
        queryResult.data.user?.teachers ?? [];

    return {
        parents: parentsDetails,
        teachers: teacherDetails,
    };
};
